@if (!loading && !allProducts.length) {
  <div class="fui-header-hero products-page m-b-50 m-t-20">
    <div>
      <div class="d-flex justify-content-center m-b-20">
        <myp-svg id="fender-logo" class="svg-white" width="100" height="50" style="margin-right: 20px" />
        <myp-svg id="presonus-logo" class="svg-white" width="130" height="50" />
      </div>
      <div class="d-flex justify-content-center m-b-30 flex-wrap">
        <myp-svg id="jackson-logo" class="svg-white m-x-10" width="90" height="45" />
        <myp-svg id="charvel-logo" class="svg-white m-x-10" width="90" height="45" />
        <myp-svg id="evh-logo" class="svg-white m-x-10" width="90" height="45" />
        <myp-svg id="gretsch-logo" class="svg-white m-x-10" width="90" height="45" />
      </div>
      @if (user) {
        <fui-heading [text]="'my_gear.register_your_gear' | translate" color="white" textAlign="center" [level]="2" fontSize="f9"></fui-heading>
        <span class="text-center">{{ "my_gear.register_your_gear_description" | translate }}</span>
        <div>
          <button class="btn btn-secondary white m-t-30" (click)="registerClicked.next(true)">{{ "my_gear.register_your_gear_button" | translate }}</button>
          <button class="btn btn-blank m-t-30 c-white" (click)="appService.goToFenderShop()">
            {{ "my_gear.register_your_gear_button_fender" | translate }}
          </button>
        </div>
      } @else {
        <fui-heading text="Track your gear in one place" color="white" textAlign="center" [level]="2" fontSize="f9"></fui-heading>
        <span class="text-center">Sign in or create an account to register your Fender and PreSonus gear, access downloads and updates, and unlock exclusive content.</span>
        <div>
          <button class="btn btn-secondary white m-t-30" (click)="appService.redirectToConnect(true, false)">Sign in or create account</button>
          <a class="btn btn-blank m-t-30 c-white" href="https://www.fender.com?utm_source=Fender&amp;utm_medium=my_fender" target="_blank" rel="noopener noreferrer">
            {{ "my_gear.register_your_gear_button_fender" | translate }}
          </a>
        </div>
      }
    </div>
  </div>
}

<div class="content-constrained">
  <!--
    Filter controls (search / sort / view / results / refresh) moved into the hero as
    of 2026-09-01 — see main-products.component.html's `.fui-hero-actions-row`. The
    old inline `<fui-content-filter>` + `<hr>` row lived here and was removed with
    that migration. The sr-only announcement below stays on the list level so assistive
    tech still hears filter-result updates as the user types in the hero search box.
  -->
  <div class="sr-only" aria-live="assertive" role="status">{{ filterAnnouncement }}</div>
  @if (loading) {
    <div class="product-list m-t-10">
      <myp-skeleton-loader class="grid-container pad-4" type="product-tile" [number]="19"></myp-skeleton-loader>
    </div>
  }
  @if (allProducts.length) {
    <div class="product-list position-relative refine-content">
      <div class="fui-sidebar-content-container">
        @if (showFilterOptions && hasMoreThanOneCategory) {
          <fui-sidebar-filter #fuiSidebarFilter [visible]="showFilterOptions && hasMoreThanOneCategory" [hideButtonText]="'Done'" [hideButtonIcon]="'times'" (hideClicked)="showFilterOptions = false">
            <!--
              `[config]` and `[selectedItem]` are component fields, NOT inline literals /
              getters. Both inputs feed `ngOnChanges` in fui-filter-content, and a new
              reference on every change-detection pass makes it rebuild its whole item list
              — which re-created the category links mid-click and swallowed clicks while the
              page was still settling. See `selectedCategoryAsFilterItem` in the component.
            -->
            <fui-filter-content
              [items]="productCategoriesWithLabels"
              [selectedItem]="selectedCategoryAsFilterItem"
              [loading]="false"
              [config]="filterContentConfig"
              (itemSelected)="selectProductCategory($event)"
            ></fui-filter-content>
          </fui-sidebar-filter>
        }
        @if (appService.prefersGrid) {
          <div class="grid-container pad-4">
            <myp-product-tile (registerProductClicked)="registerClicked.next(true)" class="register-product-tile" [registerProductTile]="true"></myp-product-tile>
            @if (productService.simpleProductList) {
              @for (prod of displayedProducts; track prod) {
                @if (!prod.filtered) {
                  <myp-product-tile (tileClicked)="go(prod)" [product]="prod"></myp-product-tile>
                }
              }
            }
          </div>
        }
        @if (!appService.prefersGrid) {
          <div class="fui-layout-pad-content m-t-30" [class.fui-sidebar-shown]="showFilterOptions">
            <!-- <myp-product-tile (registerProductClicked)="registerClicked.next(true)" class="register-product-tile force-list m-b-10" [registerProductTile]="true"></myp-product-tile> -->
            <div class="list-register-product m-b-10" role="group" [attr.aria-label]="'newdash.register_product' | translate" (click)="registerClicked.next(true)">
              <fa-icon icon="plus-circle" class="register-product-icon"></fa-icon>
              <div class="register-product-content text-left">
                {{ "newdash.prod_page_slug" | translate }}
              </div>
              <button type="button" class="btn btn-secondary register-product-btn text-nowrap" role="link" tabindex="0" #register>{{ "newdash.register_product" | translate }}</button>
            </div>

            @for (prod of displayedProducts; track prod) {
              @if (!prod.filtered) {
                <myp-list-item
                  [title]="prod.title"
                  [photo]="prod.imageUrl"
                  [showBackground]="true"
                  [showUnreadBadge]="userService.userMetadataLoaded && (!userService.userMetadata.products_seen || !userService.userMetadata.products_seen[prod.id])"
                  [metadata]="[
                    {
                      title: ('products.registered' | translate),
                      value: prod.aquired || prod.releaseDate | date,
                    },
                  ]"
                  marginBottom="10px"
                  (itemClicked)="go($event)"
                  [imageRound]="false"
                  [item]="prod"
                >
                  <div class="button-content">
                    @if (prod && prod.categoryId == "software") {
                      <button
                        class="m-r-10 fa-button"
                        (keyup.enter)="downloadInstaller(prod); $event.stopPropagation()"
                        (click)="downloadInstaller(prod); $event.stopPropagation()"
                        [ngbTooltip]="'products.download_installer' | translate"
                        placement="top"
                        tooltipClass="nowrap"
                      >
                        <fa-icon aria-label="Download" icon="download"></fa-icon>
                      </button>
                    }
                    @if (prod && prod.featuredSample) {
                      <button
                        class="m-r-10 fa-button"
                        (keyup.enter)="playSample(prod, $event); $event.stopPropagation()"
                        (click)="playSample(prod, $event); $event.stopPropagation()"
                        [ngbTooltip]="'Play Sample'"
                        placement="top"
                        tooltipClass="nowrap"
                      >
                        <fa-icon aria-label="Play Sample" icon="play-circle"></fa-icon>
                      </button>
                    }
                  </div>
                </myp-list-item>
              }
            }
          </div>
        }
      </div>
    </div>
  }

  @if (allProducts.length) {
    <div style="height: 20px"></div>
  }
</div>

<!-- Modal template for mobile filter -->
